<template>
  <div class="gym-page legal-page" id="top">
    <GymNavBar />

    <main class="legal-wrapper">
      <div class="legal-container">
        <div class="legal-header">
          <h1>Πολιτική Απορρήτου</h1>
          <p class="legal-subtitle">Έκδοση: 1.1 | Ημερομηνία Ισχύος: 26 Φεβρουαρίου 2026</p>
        </div>

        <div class="legal-body">

          <h2>Γενικά</h2>

          <p>
            Η χρήση των ηλεκτρονικών σελίδων και υπηρεσιών της ctgym.cloudtec.gr (εφεξής ΙΣΤΟΣΕΛΙΔΑ) η οποία αποτελεί
            ιδιοκτησία της μονοπρόσωπης ανώνυμης εταιρείας με την επωνυμία "ΝΙΚΟΛΑΟΣ ΒΟΥΡΛΙΔΑΣ" (εφεξής ΕΤΑΙΡΕΙΑ) από
            τον επισκέπτη /χρήστη προϋποθέτει την ανεπιφύλακτη συμφωνία του με τους παρακάτω όρους χρήσης, που ισχύουν
            για το σύνολο του περιεχομένου, που περιλαμβάνεται στην ιστοσελίδα της. Συνεπώς, ο επισκέπτης/χρήστης
            οφείλει να διαβάσει προσεκτικά τους όρους αυτούς πριν από τη χρήση των υπηρεσιών του δικτυακού τόπου και
            εάν δεν συμφωνεί, οφείλει να μην κάνει χρήση των υπηρεσιών και του περιεχομένου τους. Ο επισκέπτης/χρήστης
            παρακαλείται να ελέγχει το περιεχόμενο των όρων χρήσης για ενδεχόμενες αλλαγές. Η εξακολούθηση της χρήσης
            της ΙΣΤΟΣΕΛΙΔΑΣ, ακόμη και μετά τις όποιες αλλαγές σημαίνει την ανεπιφύλακτη, εκ μέρους του επισκέπτη /
            χρήστη, αποδοχή των όρων αυτών.
          </p>

          <h2>Πνευματική ιδιοκτησία</h2>

          <p>
            Όλος ο σχεδιασμός της ιστοσελίδας, το κείμενο, τα γραφικά, η επιλογή και οι ρυθμίσεις αυτής, είναι
            ιδιοκτησία της ΕΤΑΙΡΕΙΑΣ και προστατεύονται κατά τις σχετικές διατάξεις του ελληνικού δικαίου, του
            ευρωπαϊκού δικαίου και των διεθνών συμβάσεων. Επιφυλασσόμενων όλων των δικαιωμάτων, κάθε κείμενο ή εικόνα
            που φέρει τα σύμβολα CLOUDTEC GYM είναι σήματα ή καταχωρημένα σήματα και χρησιμοποιούνται στο παρόν κατόπιν
            αδείας των αντίστοιχων ιδιοκτητών τους.
          </p>

          <h2>Προστασία προσωπικών δεδομένων</h2>

          <p>
            Η ΙΣΤΟΣΕΛΙΔΑ ενημερώνει τον επισκέπτη/εγγεγραμμένο χρήστη και ο επισκέπτης/εγγεγραμμένος χρήστης
            αναγνωρίζει ότι είναι ενήμερος για τα κάτωθι: α) Επεξεργασία Προσωπικών Δεδομένων: Η ΕΤΑΙΡΕΙΑ θα
            επεξεργάζεται τα προσωπικά δεδομένα του επισκέπτη/εγγεγραμμένου χρήστη, όπως αυτά δηλώνονται από τον ίδιο
            κατά τηv αποστολή των φορμών επικοινωνίας, προκειμένου να πραγματοποιηθεί η επικοινωνία μαζί του. Περαιτέρω
            και εφόσον ο επισκέπτης έχει δώσει την σχετική συγκατάθεση του θα δύναται να επεξεργάζεται τα προσωπικά
            του δεδομένα για την αποστολή εμπορικών ενημερωτικών και προωθητικών μηνυμάτων ή/και για την κατάρτιση
            αγοραστικού προφίλ του χρήστη και την βελτίωση της διαχείρισης του πελατολογίου της και της λειτουργίας
            ΙΣΤΟΣΕΛΙΔΑΣ. Προκειμένου να διενεργηθεί οποιαδήποτε επικοινωνία μέσω του ιστότοπου της ΕΤΑΙΡΕΙΑΣ,
            ζητούνται: το πλήρες ονοματεπώνυμο η ηλεκτρονική διεύθυνση (e-mail) του επισκέπτη. Καμία άλλη επεξεργασία
            ή διαβίβαση των δεδομένων των χρηστών δεν θα γίνεται από την ΙΣΤΟΣΕΛΙΔΑ εκτός από τις άνωθεν επεξεργασίες
            για τις οποίες έχει λάβει την προηγούμενη συγκατάθεση των χρηστών ή αν απαιτηθεί από το Νόμο ή αρμόδια
            εποπτική ή δικαστική αρχή. Έχετε τη δυνατότητα να ανακαλέσετε οποτεδήποτε την συγκατάθεση αυτή και να μην
            λαμβάνετε τέτοιου είδους επικοινωνίες από την ΙΣΤΟΣΕΛΙΔΑ στέλνοντας το αίτημα σας μέσω e-mail στην
            ηλεκτρονική διεύθυνση <a href="mailto:info@cloudtec.gr">info@cloudtec.gr</a>.
          </p>

          <h2>Ασφάλεια</h2>

          <p>
            Το πρωτόκολλο SSL (Secure Sockets Layer), είναι σήμερα το παγκόσμιο standard στο διαδίκτυο για την
            πιστοποίηση δικτυακών τόπων (websites) στους δικτυακούς χρήστες και για την κρυπτογράφηση στοιχείων μεταξύ
            των δικτυακών χρηστών και των δικτυακών εξυπηρετητών (web servers).
          </p>
          <p>
            Μία κρυπτογραφημένη SSL επικοινωνία απαιτεί όλες τις πληροφορίες που αποστέλλονται μεταξύ ενός πελάτη και
            ενός εξυπηρετητή (server) να κρυπτογραφούνται από το λογισμικό αποστολής και να αποκρυπτογραφούνται από το
            λογισμικό αποδοχής, προστατεύοντας έτσι προσωπικές πληροφορίες κατά τη μεταφορά τους. Επιπλέον, όλες οι
            πληροφορίες που αποστέλλονται με το πρωτόκολλο SSL, προστατεύονται από έναν μηχανισμό που αυτόματα
            εξακριβώνει εάν τα δεδομένα έχουν αλλαχτεί κατά την μεταφορά.
          </p>
          <p>Το πιστοποιητικό SSL για την ΙΣΤΟΣΕΛΙΔΑ έχει εκδοθεί από την εταιρία πιστοποίησης Cpanel, σε συνεργασία με την Comodo.</p>

          <h2>Cookies</h2>

          <p>
            Η ΕΤΑΙΡΕΙΑ τηρεί αυστηρή πολιτική για την προστασία της ιδιωτικότητας των επισκεπτών της ΙΣΤΟΣΕΛΙΔΑΣ. Με
            το παρόν σημείωμα σας παρέχουμε περισσότερες πληροφορίες για το πώς χρησιμοποιούμε "cookies" καθώς και
            άλλα αυτοματοποιημένα μέσα προκειμένου να συλλέξουμε συγκεκριμένες πληροφορίες σχετικά με τους επισκέπτες
            των διαδικτυακών τόπων μας, όπως τον αριθμό των επισκεπτών των ιστοσελίδων μας καθώς και τους περισσότερο
            επισκεπτόμενους διαδικτυακούς τόπους μας, μέσω οποιουδήποτε φυλλομετρητή και συσκευή που χρησιμοποιείται.
            Με τη συλλογή αυτών των πληροφοριών, μαθαίνουμε να προσαρμόζουμε καλύτερα τις ιστοσελίδες μας και τη
            διαφήμισή μας προς τους επισκέπτες.
          </p>

          <h3>Ποια Cookies χρησιμοποιούμε;</h3>

          <p><strong>Απολύτως απαραίτητα cookies</strong></p>
          <p>
            Τα απολύτως απαραίτητα cookies είναι ουσιαστικής σημασίας για την ορθή λειτουργία του ιστότοπου, σας
            επιτρέπουν να κάνετε περιήγηση και να χρησιμοποιήσετε τις λειτουργίες του, όπως πρόσβαση σε ασφαλείς
            περιοχές, φόρμες επικοινωνίας και για λόγους ασφαλείας. Αυτά τα cookies δεν αναγνωρίζουν την ατομική σας
            ταυτότητα. Χωρίς αυτά τα cookies, δεν μπορούμε να προσφέρουμε αποτελεσματική λειτουργία του ιστότοπου μας.
          </p>

          <p><strong>Cookies επιδόσεων και ανάλυσης</strong></p>
          <p>
            Αυτά τα cookies συλλέγουν πληροφορίες σχετικά με τον τρόπο που οι επισκέπτες χρησιμοποιούν τον ιστότοπο,
            ποιες σελίδες επισκέπτονται συχνότερα και αν λαμβάνουν μηνύματα σφαλμάτων από ιστοσελίδες. Αυτά τα cookies
            συλλέγουν συγκεντρωτικές, ανώνυμες πληροφορίες που δεν ταυτοποιούν κάποιον επισκέπτη. Χρησιμοποιούνται
            αποκλειστικά για τη βελτίωση των επιδόσεων μίας ιστοσελίδας.
          </p>

          <h3>Πως Μπορείτε να Απενεργοποιήσετε τη Χρήση Cookies;</h3>

          <p>
            Σε περίπτωση που επιθυμείτε να ενεργοποιήσετε ή να απενεργοποιήσετε τη χρήση cookies από τις ρυθμίσεις
            του φυλλομετρητή σας, αναλόγως του φυλλομετρητή σας επισκεφθείτε τις ακόλουθες ιστοσελίδες:
          </p>
          <ul>
            <li>Internet Explorer: <a href="http://support.microsoft.com/kb/278835" target="_blank" rel="noopener">support.microsoft.com</a></li>
            <li>Firefox: <a href="http://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored" target="_blank" rel="noopener">support.mozilla.org</a></li>
            <li>Chrome: <a href="http://support.google.com/accounts/answer/61416?hl=en" target="_blank" rel="noopener">support.google.com</a></li>
            <li>Opera: <a href="http://www.opera.com/browser/tutorials/security/privacy/" target="_blank" rel="noopener">opera.com</a></li>
            <li>Safari: <a href="http://support.apple.com/kb/PH5042" target="_blank" rel="noopener">support.apple.com</a></li>
            <li>Safari for iPad and iPhone: <a href="http://support.apple.com/kb/HT1677" target="_blank" rel="noopener">support.apple.com (iOS)</a></li>
          </ul>

          <h2>Πολιτική απορρήτου εφαρμογής</h2>

          <p>
            Η παρούσα Πολιτική Απορρήτου καθορίζει τις αρχές και τους όρους υπό τους οποίους ο ΝΙΚΟΛΑΟΣ ΒΟΥΡΛΙΔΑΣ
            (εφεξής ο «Πάροχος» ή «εμείς»), με έδρα την Ελλάδα και ηλεκτρονική διεύθυνση επικοινωνίας
            <a href="mailto:info@cloudtec.gr">info@cloudtec.gr</a>, συλλέγει και επεξεργάζεται προσωπικά δεδομένα μέσω
            της εφαρμογής Cloudtec Gym (εφεξής η «Εφαρμογή») και του ιστοτόπου ctgym.cloudtec.gr.
          </p>

          <h3>Άρθρο 1: Εισαγωγή &amp; Ρόλοι</h3>
          <p>
            Το Cloudtec Gym λειτουργεί ως λογισμικό διαχείρισης για επαγγελματίες (φυσικοθεραπευτήρια, στούντιο
            pilates/yoga, γυμναστήρια).
          </p>
          <ul>
            <li>Ως προς τα δεδομένα των Χρηστών (Συνδρομητών): Ο Πάροχος ενεργεί ως Υπεύθυνος Επεξεργασίας.</li>
            <li>Ως προς τα δεδομένα των Πελατών των Χρηστών: Ο Πάροχος ενεργεί ως Εκτελών την Επεξεργασία κατ' εντολή
              του Χρήστη, ο οποίος διατηρεί την ιδιότητα του Υπευθύνου Επεξεργασίας για το πελατολόγιό του.</li>
          </ul>

          <h3>Άρθρο 2: Κατηγορίες Συλλεγόμενων Δεδομένων</h3>
          <p>Συλλέγουμε και επεξεργαζόμαστε τα εξής δεδομένα, ανάλογα με τη χρήση της Εφαρμογής:</p>
          <ul>
            <li><strong>Στοιχεία Ταυτοποίησης &amp; Επικοινωνίας Χρήστη:</strong> Ονοματεπώνυμο, ηλεκτρονική διεύθυνση
              (email), τηλέφωνο και στοιχεία επιχείρησης (επωνυμία, ΑΦΜ) για την έκδοση παραστατικών και την
              επικοινωνία.</li>
            <li><strong>Δεδομένα Πελατολογίου (καταχωρημένα από τον Χρήστη):</strong> Στοιχεία επικοινωνίας μελών,
              ιστορικό συνδρομών, πρόγραμμα συνεδριών, υπόλοιπα πληρωμών και τυχόν σημειώσεις που αφορούν την παροχή
              υπηρεσιών.</li>
            <li><strong>Τεχνικά Δεδομένα:</strong> Διεύθυνση IP, τύπος συσκευής και δεδομένα χρήσης (Analytics) για τη
              διασφάλιση της λειτουργικότητας και τη βελτίωση της εμπειρίας χρήστη.</li>
          </ul>

          <h3>Άρθρο 3: Νομική Βάση &amp; Σκοποί Επεξεργασίας</h3>
          <ul>
            <li><strong>Εκτέλεση Σύμβασης:</strong> Για την παροχή των υπηρεσιών της Εφαρμογής, τη διαχείριση ραντεβού
              και την πρόσβαση στην «Περιοχή Πελατών».</li>
            <li><strong>Συμμόρφωση με Έννομη Υποχρέωση:</strong> Για την τήρηση φορολογικών στοιχείων και
              παραστατικών.</li>
            <li><strong>Έννομο Συμφέρον:</strong> Για την ασφάλεια των συστημάτων μας και την ανάλυση της απόδοσης της
              Εφαρμογής.</li>
          </ul>

          <h3>Άρθρο 4: Διαβίβαση σε Τρίτους &amp; Ασφάλεια</h3>
          <ul>
            <li><strong>Υποδομή:</strong> Τα δεδομένα αποθηκεύονται σε κρυπτογραφημένους διακομιστές της εταιρείας
              Hostnox στη Γερμανία, διασφαλίζοντας υψηλό επίπεδο ασφάλειας και συμμόρφωσης με το GDPR.</li>
            <li><strong>Τρίτοι Πάροχοι:</strong> Χρησιμοποιούνται εργαλεία Analytics για στατιστικούς σκοπούς. Δεν
              πραγματοποιείται διαβίβαση δεδομένων σε τρίτους για διαφημιστικούς σκοπούς.</li>
            <li><strong>Πληρωμές:</strong> Οι οικονομικές συναλλαγές για τη συνδρομή στην Εφαρμογή εκτελούνται
              αποκλειστικά μέσω τραπεζικού εμβάσματος.</li>
          </ul>

          <h3>Άρθρο 5: Δικαιώματα Υποκειμένων &amp; Διαγραφή</h3>
          <p>
            Κάθε χρήστης διατηρεί τα δικαιώματα ενημέρωσης, πρόσβασης, διόρθωσης, φορητότητας και διαγραφής των
            δεδομένων του (δικαίωμα στη λήθη).
          </p>
          <ul>
            <li><strong>Διαδικασία Διαγραφής:</strong> Η Εφαρμογή παρέχει ρητή λειτουργία διαγραφής λογαριασμού και
              δεδομένων μέσω του συνδέσμου:
              <a href="https://ctgym.cloudtec.gr/settings/account" target="_blank" rel="noopener">ctgym.cloudtec.gr/settings/account</a>.
            </li>
            <li><strong>Αιτήματα:</strong> Για την άσκηση των δικαιωμάτων σας, μπορείτε να επικοινωνείτε στο
              <a href="mailto:info@cloudtec.gr">info@cloudtec.gr</a>.</li>
          </ul>

          <h3>Άρθρο 6: Εφαρμοστέο Δίκαιο</h3>
          <p>
            Η παρούσα πολιτική διέπεται από το Ελληνικό Δίκαιο και τον Γενικό Κανονισμό Προστασίας Δεδομένων (ΕΕ)
            2016/679 (GDPR).
          </p>

          <div class="legal-contact-box">
            <div class="legal-contact-title">Στοιχεία Επικοινωνίας</div>
            <p>ΝΙΚΟΛΑΟΣ ΒΟΥΡΛΙΔΑΣ</p>
            <p>Email: <a href="mailto:info@cloudtec.gr">info@cloudtec.gr</a></p>
            <p>Website: <a href="https://cloudtec.gr" target="_blank" rel="noopener">cloudtec.gr</a></p>
          </div>

        </div>
      </div>
    </main>

  </div>
</template>

<script>
import GymNavBar from './GymNavBar.vue'

export default {
  name: 'GymPrivacy',
  components: { GymNavBar },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');

/* ══════════════════════════════════════════
   BASE
══════════════════════════════════════════ */
.gym-page {
  font-family: 'Inter', sans-serif;
  background: #0f1923;
  color: rgba(255, 255, 255, 0.85);
  min-height: 100vh;
}

/* ══════════════════════════════════════════
   LAYOUT
══════════════════════════════════════════ */
.legal-wrapper {
  padding: 60px 1rem 80px;
}

.legal-container {
  max-width: 780px;
  margin: 0 auto;
}

/* ══════════════════════════════════════════
   HEADER
══════════════════════════════════════════ */
.legal-header {
  margin-bottom: 2.5rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.legal-header h1 {
  font-size: clamp(1.8rem, 4vw, 2.5rem);
  font-weight: 800;
  color: #fff;
  margin: 0 0 0.5rem;
}

.legal-subtitle {
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.4);
  margin: 0;
}

/* ══════════════════════════════════════════
   BODY
══════════════════════════════════════════ */
.legal-body h2 {
  font-size: 1.1rem;
  font-weight: 700;
  color: #FFC947;
  margin: 2rem 0 0.75rem;
}

.legal-body h3 {
  font-size: 0.975rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
  margin: 1.5rem 0 0.5rem;
}

.legal-body p {
  font-size: 0.95rem;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.7);
  margin: 0 0 1rem;
}

.legal-body ul {
  margin: 0 0 1.25rem 1.25rem;
  padding: 0;
}

.legal-body ul li {
  font-size: 0.95rem;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 0.4rem;
}

.legal-body a {
  color: #FFC947;
  text-decoration: none;
}

.legal-body a:hover {
  text-decoration: underline;
}

/* ══════════════════════════════════════════
   CONTACT BOX
══════════════════════════════════════════ */
.legal-contact-box {
  margin-top: 2.5rem;
  padding: 1.25rem 1.5rem;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
}

.legal-contact-title {
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #FFC947;
  margin-bottom: 0.75rem;
}

.legal-contact-box p {
  margin: 0 0 0.3rem;
  font-size: 0.9rem;
}

/* ══════════════════════════════════════════
   RESPONSIVE
══════════════════════════════════════════ */
@media (max-width: 768px) {
  .legal-wrapper {
    padding: 40px 1.25rem 60px;
  }
}
</style>
